import React from 'react'; // Remove the useState import if you are not using it
import TopBadges from '../TopBadges';
import Accordian from './Accordian';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToBucket, removeItemFromBucket } from '../../features/bucket/bucketSlice';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { everyDayMeals } from '../../constants';
import Map from '../Map';

const DeliveryModal = ({ isModalOpen, setIsModalOpen, data }) => {
  console.log("🚀 ~ file: ItemModal.jsx:10 ~ ItemModal ~ data:", data);

  const dispatch = useDispatch();

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const addToBucket = (data) => {
    dispatch(addItemToBucket(data));
  };
  const removeFromBucket = (data) => {
    dispatch(removeItemFromBucket(data));
  };

  const bucket = useSelector((state) => state.bucket.items);
  console.log("🚀 ~ file: ItemModal.jsx:24 ~ ItemModal ~ bucket:", bucket);

  const currentItem = everyDayMeals.find((item) => item?.id === data?.id);
  console.log("🚀 ~ file: ItemModal.jsx:26 ~ ItemModal ~ currentItem:", currentItem);

  return (
    <div>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Modal Overlay */}
        <div onClick={closeModal} className="fixed inset-0 bg-black opacity-50 cursor-pointer z-50"></div>

        {/* Modal Content */}
        <div className="bg-white p-4 pt-0 rounded-2xl shadow-lg w-[40%] z-50">
          <TopBadges />
          <div className="flex justify-end">
          <button onClick={closeModal} className="text-black bg-light-secondary rounded-sm hover:text-gray-800 focus:outline-none w-12 h-9 flex justify-center items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <h1 className="text-xl text-center font-bold">Select Your Location for Delivery</h1>
          <hr className='w-full h-[2px] bg-gray-200 my-4'  />
            <Map/>
          </div>
          <div>
          </div>
      </div>
    </div>
  );
};

export default DeliveryModal;
